var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileFillBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.5C7 11.25 9.25 13.5 12 13.5C14.75 13.5 17 11.25 17 8.5V7C17 4.25 14.75 2 12 2C9.25 2 7 4.25 7 7V8.5Z",
    fill: "#212D4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.4C2 21.28 2.72 22 3.6 22H20.38C21.26 22 21.98 21.28 21.98 20.4V15.75C21.98 15.51 21.98 15.25 21.86 15.13C21.49 14.26 20.36 13.5 18.61 12.88C17.37 15.26 14.86 16.88 11.99 16.88C9.12 16.88 6.62 15.26 5.37 12.88C3.62 13.51 2.5 14.25 2.12 15.13C2 15.37 2 15.5 2 15.75V20.4Z",
    fill: "#212D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFillBlack);
export default __webpack_public_path__ + "static/media/profile-fill-black.fb83ad5272b5931f8f4038ef4d4f27a3.svg";
export { ForwardRef as ReactComponent };